import {FormModel} from "./form.model.abstract";
import {ValidatorFn} from "@angular/forms";

/**
 * Two date fields
 * @inheritDoc
 */
export class FormModelDates extends FormModel {

  /**
   * @inheritDoc
   */
  public type = 'dates';

  /**
   * Number of years to preset the second value if the first is blurred
   */
  public presetSecondFieldYears: number = 0;

  /**
   * @inheritDoc
   * @param id
   * @param fieldIds The ids of the subfields.
   * @param validators
   * @param unit
   * @param values List of initial values for the subfields.
   * @param info
   * @param presetSecondFieldYears
   */
  constructor(id: string, fieldIds: string[], validators: ValidatorFn[] = [], unit: string = null, values: string[] = [], info: boolean = true, presetSecondFieldYears: number = 0) {
    super(id, validators, unit, null, info);

    this.fieldData["ids"] = fieldIds;
    this.fieldData["values"] = values;
    this.presetSecondFieldYears = presetSecondFieldYears;
  }

  /**
   * get a clone of the current object
   */
  public clone(): FormModelDates {
    // @ts-ignore
    return new this.constructor(this.id, this.fieldData["ids"], this.validators, this.unit, this.fieldData["values"], this.info);
  }

  /**
   * @inheritDoc
   */
  getIds(): string[] {
    return this.fieldData["ids"];
  }
}
